import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { useController, UseControllerProps, FieldValues } from 'react-hook-form'
import { FormControlProps, FormHelperText, SelectProps } from '@mui/material'

type Item = {
  name: string
  id: number
}

type ISelect = {
  items: Item[] | undefined
  disabledValues?: number[]
}

type Props = ISelect &
  SelectProps &
  FormControlProps &
  UseControllerProps<FieldValues>

export const sxMultipleSelect = () => ({
  width: '100%',
  backgroundColor: '#fff',
  borderRadius: '4px',

  ['.MuiInputLabel-root']: {
    color: '#0072bcb3',
    top: '-3px',
    ['&.Mui-focused']: {
      top: '13px',
    },
    ['&.MuiInputLabel-shrink']: {
      top: '13px',
    },
  },
  ['.MuiSelect-select']: {
    padding: '20px 12px 5px',
    border: '1px solid #0072BC !important',
  },
  ['.Mui-error']: {
    ['.MuiSelect-select']: {
      borderColor: '#d32f2f !important',
    },
  },
  ['.MuiOutlinedInput-notchedOutline']: {
    border: 'none',
    top: 0,
    ['legend']: {
      display: 'none',
    },
  },
  ['.MuiFormHelperText-root']: {
    position: 'absolute',
    color: '#d32f2f',
    bottom: '-18px',
  },
})

const MultipleSelect = ({
  label,
  items,
  control,
  name,
  disabled,
  disabledValues,
}: Props) => {
  const {
    field,
    formState: { errors },
  } = useController({
    name,
    control,
  })

  return (
    <>
      <FormControl
        sx={sxMultipleSelect}
        disabled={disabled}
      >
        <InputLabel
          sx={{
            color: errors[name]?.message ? '#d32f2f !important' : '',
          }}
        >
          {label}
        </InputLabel>
        <Select
          multiple
          error={!!errors[name]}
          value={Array.isArray(field.value) ? field.value : []}
          onChange={field.onChange}
        >
          {items?.map((item) => (
            <MenuItem
              key={item?.id}
              value={item?.id}
              disabled={disabledValues?.includes(item.id)}
            >
              {item?.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{errors[name]?.message as string}</FormHelperText>
      </FormControl>
    </>
  )
}

export default MultipleSelect
